import { render, staticRenderFns } from "./CommandPalette.vue?vue&type=template&id=523765af&scoped=true&"
import script from "./CommandPalette.vue?vue&type=script&lang=js&"
export * from "./CommandPalette.vue?vue&type=script&lang=js&"
import style0 from "./CommandPalette.vue?vue&type=style&index=0&id=523765af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523765af",
  null
  
)

export default component.exports